import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { TooltipsStyled } from './TooltipsStyled';

export default ({ info }) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const useStyles = makeStyles({
    popper: {
      maxWidth: '264px',
      background: '#fff',
      border: '0.5px solid #9e9e9e',
      filter: 4,
      opacity: 0.92,
      borderRadius: 4,
      zIndex: 9999,
      // border: 0,
      // color: 'white',
      // height: 48,
      // padding: '0 30px',
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    },
    tooltip: {
      background: '#fff',
      color: '#616161',
      fontSize: '12px',
      listStyle: 'none',
      // 文字12px，#616161，上下左右边距16
    },
    label: {
      textTransform: 'capitalize',
      padding: '8px',
    },
  });
  const classes = useStyles();
  return (
    <TooltipsStyled theme={themeContext} brand={brandContext}>
      <Tooltip
        // overlayClassName="tooptipMsgBox"
        placement="bottom"
        title={info}
        // arrow
        // open={true}
        className={'icon_question'}
        classes={{ popper: classes.popper, tooltip: classes.tooltip }}
      >
        <IconButton className="icon-wrap" aria-label="delete">
          <SvgIconML name={'tooltipIcon'} size={16}></SvgIconML>
        </IconButton>
      </Tooltip>
    </TooltipsStyled>
  );
};
